import Image from "next/image";
import { urlFor } from "@/sanity/lib/image";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { Pin } from "lucide-react";

import DemoIframe from "@/components/layout/DemoIframe";
import BookmarkInToolBtn from "../layout/Buttons/BookmarkInToolBtn";

const ToolCard = ({ tool }) => {
  const maxLength = 180;

  return (
    <article
      className="relative border neue_machina_regular border-black border-dashed p-3 shadow box_shadow transition h-fit"
      style={{ letterSpacing: "0" }}
    >
      <div>
        {tool.label === "featured" && (
          <div className="absolute top-4 -left-3 rotate-[-45deg] bg-yellow-300 text-yellow-900 shadow-lg border border-yellow-500">
            <div className="flex items-center justify-center text-xs px-2 font-bold uppercase">
              <Pin size={18} strokeWidth={1.5} /> <span>Pinned</span>
            </div>
          </div>
        )}
        {tool.label === "most_popular" && (
          <div className="absolute top-4 -left-3 rotate-[-45deg] bg_red color_white shadow-lg border border-red-500">
            <div className="flex items-center justify-center text-xs px-2 font-bold uppercase">
              <span>Popular</span>
            </div>
          </div>
        )}
      </div>

      {/* Tool Icon */}
      {tool.image && (
        <Image
          src={urlFor(tool.image).url()}
          alt={tool.title}
          width={1000}
          height={1000}
          className="mb-2 object-contain w-full h-full border border-black"
        />
      )}

      {/* Tool Title */}
      <div className="flex justify-between items-center flex-wrap gap-2 py-4">
        <h2 className="text-2xl shadow_hand underline underline-offset-4">
          <a href={tool.tool_url} target="_blank" rel="noopener noreferrer">
            {tool.title}
          </a>
        </h2>
        <small className="text-xs text-green-700 font-semibold uppercase agile spacing">
          {tool.price}
        </small>
      </div>

      {/* Tool Categories */}
      <div className="flex flex-wrap gap-1 pb-2">
        {tool.categories?.map((cat, i) => (
          <span
            key={i}
            className="text-[10px] px-2 py-1 bg-gray-200 text-gray-700"
          >
            {cat}
          </span>
        ))}
      </div>

      {/* Tool Description */}
      <p className="text-sm text-gray-600 mt-2 mb-1">
        {tool.description.length > maxLength
          ? `${tool.description.slice(0, maxLength)}... `
          : tool.description}
      </p>

      <div className="flex justify-center gap-x-3 items-center mt-3">
        <Link
          href={`/tool/${tool.slug}`}
          className="underline underline-offset-4 hover:underline-offset-2 cursor-pointer text-sm transition-all color_black"
        >
          {tool.title} - Details
        </Link>
        <BookmarkInToolBtn tool={tool} size={32} />
      </div>

      {/* Buttons */}
      <div className="flex flex-wrap justify-center gap-4 mt-5 mb-2 agile spacing">
        <a href={tool.tool_url} target="_blank" rel="noopener noreferrer">
          <Button
            variant="outline"
            className="rounded-none uppercase text-blue-600 border-blue-600 hover:bg-blue-100"
          >
            Visit Tool
          </Button>
        </a>

        <DemoIframe demoLink={tool.demo_link} />
      </div>
    </article>
  );
};

export default ToolCard;
